'use strict'

import Form from "../utils/Form";

class Home{
    constructor(){
		var self=this;
		let wheelsActualRotation = 0;
		
		(new Form()).done((data) => {
			if(data.status==200){
				var str=location.pathname;
				if (str.charAt(str.length - 1) !== '/') {
					str = str + '/';
				}
				location.href = location.origin + str + 'completado/' + location.search;
			}
        });

		new WOW({
			boxClass: "wow",
			animateClass: 'animated',
			offset: 0,
			mobile: true,
			live: true,
		  }).init();
	
        $('select').selectric();

		$(document).ready(function(){
			$(window).scroll(function(e){
				self.parallax();
			});
			
		  });

        var options;

        var slideWidth;
        if ( $(window).width() > 768 && $(window).width() < 1023) {
            slideWidth = 950;
        } else if ($(window).width() > 1024) {
			slideWidth = 650;
		} else {
            slideWidth = 600;
        }

        if ($(window).width() > 768 && $(window).width() < 1023) {
            options = {
                slideWidth,
                minSlides: 1,
                maxSlides: 3,
                moveSlides: 1,
                pager: false,
                controls: true,
				slideMargin: 0,
				shrinkItems: false,
				responsive:false,
                speed: 1200,
                auto: false,
				infiniteLoop: true,
                onSlideBefore: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car.active').addClass('inactive');
                    setTimeout(function() {
                        $(e).closest('.bx-wrapper').find('.car.active').removeClass('active');
                    }, 500);	
					console.log(e);															
                },
                onSlideAfter: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car').removeClass('active').removeClass('inactive');
                    $(e).addClass('active');
                },
				onSlideNext: function(e, o, n) {			
					const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
					const rotationFactor = 120;
					wheelsActualRotation-=rotationFactor;
					wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
				},
				onSlidePrev: function(e, o, n) {
					const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
					const rotationFactor = 120;					
					wheelsActualRotation+=rotationFactor;
					wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
				}
            }
        }else if ($(window).width() > 1024) {
			options = {
                slideWidth,
				minSlides: 1,
                maxSlides: 1,
                moveSlides: 1,
                pager: false,
                controls: true,
				slideMargin: 0,
				shrinkItems: true,
				responsive:true,
                speed: 1200,
                auto: false,
				infiniteLoop: true,
                onSlideBefore: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car.active').addClass('inactive');
                    setTimeout(function() {
                        $(e).closest('.bx-wrapper').find('.car.active').removeClass('active');
                    }, 500);	
					console.log(e);															
                },
                onSlideAfter: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car').removeClass('active').removeClass('inactive');
                    $(e).addClass('active');
                },
				onSlideNext: function(e, o, n) {			
					const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
					const rotationFactor = 120;
					wheelsActualRotation-=rotationFactor;
					wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
				},
				onSlidePrev: function(e, o, n) {
					const wheels = $(e).closest('.bx-wrapper').find('.car-image-wheel');
					const rotationFactor = 120;					
					wheelsActualRotation+=rotationFactor;
					wheels.css('transform', `rotate(${wheelsActualRotation}deg)`);
				}
            }
		} else {
            options = {
                slideWidth,
                minSlides: 1,
                maxSlides: 3,
                moveSlides: 1,
                pager: false,
                controls: true,
				slideMargin: 0,
				shrinkItems: true,
                auto: false,
                onSlideBefore: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car.active').addClass('inactive');
                    setTimeout(function() {
                        $(e).closest('.bx-wrapper').find('.car.active').removeClass('active');
                    }, 500)
					console.log(e);
					/*if(e.find(".textAnimation span").hasClass("undefined")){
						e.find(".textAnimation span").toggleClass("undefined animated");	
					}*/	
                },
                onSlideAfter: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car').removeClass('active').removeClass('inactive');
                    $(e).addClass('active');
                }
            }
        };
        var cars = $('section.models .cars#autos').bxSlider(options);

        $('section.models .types a').on('click', function(e) {
            e.preventDefault();
            $('section.models').addClass('stopAnimation');
            var type = $(this).data('type');
            $('section.models .types a').removeClass('active');
			$(this).addClass('active');
			
			navTabActiveLineAnimated();

            $('section.models .cars-container').animate({
                opacity: 0
            }, 700, function() {
				const wheels = $('.bx-wrapper').find('.car-image-wheel');
				wheels.css('transform', `rotate(0deg)`);
                cars.destroySlider();
				wheelsActualRotation = 0;
                $('section.models .cars#' + type).find('.car:first-child').addClass('active');								
                cars = $('section.models .cars#' + type).bxSlider(options);
                $('section.models .cars-container').animate({
                    opacity: 1
                }, 700)
            })
        });

		
		$('section.hero .chevronDown').on('click', function() {
			$('section.hero').addClass('blur');
			setTimeout(function() {
				$('section.hero').removeClass('blur');
			}, 1500);
		});
		
        var scene = $('.parallax');
        /*$.each(scene, function(i, s) {
            var parallaxInstance = new Parallax($(s)[0], {
              relativeInput: true
            });

			//parallaxInstance.friction(0.075, 0.075);
        })*/

        if(window.navigator.userAgent.toLowerCase().indexOf("chrome") > 0) {
            $("body").on("mousedown", ".car .image", function(e) { 
                var href = $(this).attr('href');
                document.location.href = href;
            }); 
		}
		
		setTimeout(function() {
			navTabActiveLineAnimated();
		}, 1000);		
    }
	
	parallax(){
		var scrolled = $(window).scrollTop();
		$('.hero').css('top',-(scrolled*0.010)+'px');
		$('.hero > .caption').css('top',-(scrolled*-0.005)+'px');
		$('.hero > .caption').css('opacity',1-(scrolled*.00175));
	  };

	initSliderHome(){
		var self=this;
		
		self.player={};
		self.nextSliderTimer=null;
		var pager = $('section.hero .slider .slide').length > 1;
		window.heroSlider = $('section.hero .slider').bxSlider({
			mode: 'fade',
			pager,
			controls: false,
			touchEnabled: false,
			autoStart: false,
			auto: false,
			stopAutoOnClick: true,
			speed: 3000,
			buildPager: function() {
				return '<svg height="30" width="30"> <circle cx="15" cy="15" r="14" stroke="white" stroke-width="1" fill="transparent" /> </svg>'
			},
			onSliderLoad: function(currentIndex){
				self.showSliderHome(currentIndex);		
				setTimeout(function(){
					$('section.hero .slider .slide:nth-child('+currentIndex+')').addClass('active');
				}, 4000);		
				
			},
			onSlideAfter: function(dom, oldIndex, newIndex){
				self.showSliderHome(newIndex);
			},
			onSlideBefore:function(dom, oldIndex, newIndex){
		
				$('section.hero .slider .slide').removeClass("in-next in-prev out-slide in-slide active");					
				

				if(oldIndex < newIndex || newIndex == 0 && oldIndex != 1){
					if(oldIndex == 0 && newIndex == 2){
						dom.next().addClass("out-slide")
						dom.addClass("in-prev active");						
					}else{
						dom.prev().addClass("out-slide")
						dom.addClass("in-next active");						
					}					
				}else{
					dom.addClass("in-prev");
					dom.next().addClass("out-slide")
				}

				dom.addClass("in-slide active");

				if(dom.find(".textAnimation span").hasClass("undefined")){
					dom.find(".textAnimation span").removeClass("undefined").addClass('animated');	
					
				}				
			}, 
		});

		$('section.hero .bx-wrapper .bx-pager.bx-custom-pager a').on('click', function() {
            $('section.hero .bx-wrapper .bx-pager.bx-custom-pager').addClass('stopAnimation');
            heroSlider.stopAuto();
        })

	}
	
	showSliderHome(index){
		var self=this;
		
		if(self.nextSliderTimer){
			clearTimeout(self.nextSliderTimer);
			self.nextSliderTimer=null;
		}
		
		$('section.hero .slider .slide').eq(index).addClass('active');

		var dom=$('section.hero .slider .slide').eq(index);
		if(dom.find('.video-wrapper').length==1){
			self.player = new YT.Player('player', {
				playerVars: { 
					'autoplay': 1,
					'showinfo': 0,
					'autohide': 1,
					'loop': 0,
					'controls': 0,
					'modestbranding': 1,
					'rel': 0,
					'playsinline': 1
					
				},
				height: '100%',
				width: '100%',
				videoId: dom.find('.video-wrapper').data('video'),
				events: {
					'onReady': self.YTPlayerReady,
					'onStateChange': self.YTStateChange
				}
			});
		}else{
			self.nextSliderTimer=setTimeout(function(){
				window.heroSlider.goToNextSlide();
			}, 8000);
		}		
	}
	
	YTPlayerReady(event) {
		var self=this;
		
		event.target.playVideo();
		event.target.mute(); // comment out if you don't want the auto played video muted
		
		const currentVideo=event.target;
		const videoTime=currentVideo.getDuration()-2;
		const videoInterval=setInterval(function(){
			if(videoTime<currentVideo.getCurrentTime()){
				clearInterval(videoInterval);
				if($('section.hero .slider .slide').length==1){
					event.target.seekTo(0);
					event.target.playVideo();
					event.target.mute(); // comment out if you don't want the auto played video muted
				}else{
					event.target.pauseVideo();
					setTimeout(function(){
						event.target.destroy();
						window.heroSlider.goToNextSlide();
					}, 500);
				}				
			}
		}, 500);
	}

	YTStateChange(event) {
		var self=this;
		if (event.data == -1) {
			event.target.seekTo(0);
			event.target.mute(); // comment out if you don't want the auto played video muted
			event.target.playVideo();
		}
	}

}

export default Home;